import React from 'react';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

const PlayButton = ({setIsPlaying, isPlaying, icons}) => {
	return (
		<Button
			classNames="play-button"
			onClick={() => {
				setIsPlaying(!isPlaying);
			}}
		>
			{isPlaying
				? <Icon
					name={icons.pause}
					height={icons.height}
					width={icons.width}
				/>
				: <Icon
					name={icons.play}
					height={icons.height}
					width={icons.width}
				/>
			}
		</Button>
	);
};

export default PlayButton;
